import React, { useEffect, useRef, useContext, useState } from 'react';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Dialog } from "primereact/dialog";
import { Calendar } from 'primereact/calendar';
import { InputMask } from 'primereact/inputmask';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import { ConfigContext } from '../ConfigContext';
import { toastRef } from './GlobalToastRef';
import { addLocale } from 'primereact/api';
import moment from 'moment';
import { useGetUserQuery } from '../api/userApi';

import {        
    useCreateServiceRegistrationMutation,        
    useGetServiceTypesQuery,
    useGetServiceHoursQuery,
    useGetSettingsQuery,
    useGetServiceWorkingWeekdaysQuery

} from '../api/serviceApi';
import { InputTextarea } from 'primereact/inputtextarea';

export default function ServiceRegistrationDialog({onHide}){    
    const configContext = useContext(ConfigContext)
    const firmId = configContext.firmId    
    const formRef = useRef(null)

    const [visible, setVisible] = useState(true)
    const [success, setSuccess] = useState(false)
    const [successData, setSuccessData] = useState(false)
            
    const {data: user, refetch: refetchUser, isFetching: isUserLoading,  
        isSuccess: isUserGetSucces, isError: isUserGetError} = useGetUserQuery()        

    const {data: settings, refetch: refetchSettings, isFetching: isSettingsLoading,  
        isSuccess: isSettingsGetSucces, isError: isSettingsGetError} = useGetSettingsQuery({firmId})        

    const {data: disabledWeekdays, refetch: refetchDisabledWeekdays, 
            isFetching: isDisabledWeekdaysLoading,  isSuccess: isDisabledWeekdaysGetSucces, 
            isError: isDisabledWeekdaysGetError} = useGetServiceWorkingWeekdaysQuery({firmId})        
    

    const {data: serviceTypes, refetch: refetchServiceTypes,
            isFetching: isServiceTypesFetching, isSuccess: isServiceTypesSuccess, isError: isServiceTypesError} = useGetServiceTypesQuery({firmId})
    
    const [create, { isLoading: isCreating, isSuccess: isCreated, isError: isCreateError  }] = useCreateServiceRegistrationMutation();    
    
    const [isOtherServiceType, setIsOtherServiceType] = useState(false)

    
    const [hours, setHours] = useState([])
    const [hoursMessage, setHoursMessage] = useState(null)
    const [noRecordsMessage, setNoRecordsMessage] = useState(null)
    
    const [error, setError] = useState(null)
    const [localServiceTypes, setLocalServiceTypes] = useState([{title: 'Другой', 'id': -1}])    
    
    const [localData, setLocalData] = useState({})
    const { control, formState: { errors }, handleSubmit, watch, reset, setValue } = useForm({ defaultValues: localData, mode: 'onChange' });

    const formDate = useWatch({ name: "date", control});
    const formTime = useWatch({ name: "time", control});
    // const formServiceType = useWatch({ name: "service_type", control});

    const {data: serviceHours, refetch: refetchServiceHours,
        isFetching: isServiceHoursFetching, isSuccess: isServiceGoursSuccess,
        isError: isServiceHoursError} = useGetServiceHoursQuery({firmId, date: moment(formDate).format('YYYY-MM-DD'), find_next_available: formDate ? 0 : 1})    


    addLocale('ru',{
        firstDayOfWeek: 1,
        dayNames: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
        dayNamesShort: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
        dayNamesMin: ["В", "П", "В", "С", "Ч", "П", "С"],
        monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
        monthNamesShort: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
        today: "Сегодня",
        clear: "Очистить"
    })

    useEffect(() => {
        refetchServiceTypes({firmId})
        .unwrap()
        .then((res) => {
            res.count && setLocalServiceTypes([...res.results, ...[{title: 'Другой', 'id': -1}]])            
        })        
        refetchUser()
        refetchSettings()
    }, []);

    useEffect(() => {
        if(isServiceGoursSuccess && !formDate){
            setValue('date', moment(serviceHours.date, 'YYYY-MM-DD').toDate())
        }
    }, [isServiceGoursSuccess]);

    useEffect(() => {
        if(formDate){                         
            refetchServiceHours({firmId, date: moment(formDate).format('YYYY-MM-DD')})
            .unwrap()
            .then((res) => {                
                setHours((state) => [])                
                res.hours.map((item) => {
                    const hourParts = item.split(':')                    
                    setHours((state) => [...state, {id: item, title: `${hourParts[0]}:${hourParts[1]}`}])
                })
                setHoursMessage(res.title)
                setNoRecordsMessage(res.no_records_title ? res.no_records_title : null)                
            })        
        }
        
    }, [formDate]);

    // useEffect(() => {
    //     if(isServiceGoursSuccess){
    //         setHours((state) => [])                
    //         serviceHours.hours.map((item) => {
    //             const hourParts = item.split(':')                    
    //             setHours((state) => [...state, {id: item, title: `${hourParts[0]}:${hourParts[1]}`}])
    //         })
    //         setHoursMessage(serviceHours.title)
    //         setNoRecordsMessage(serviceHours.no_records_title ? serviceHours.no_records_title : null)                
    //     }
    // }, [isServiceGoursSuccess])

    useEffect(() => {        
        hours.filter((item) => formTime == item.id).length || setValue('time', hours && hours.length ? hours[0].id : null)
    }, [hours])

    

    
    const onSubmit = (formData) => {        
        let _data = {
            ...formData,
            firm: firmId,
            service_type: formData.service_type == -1 ? null : formData.service_type,
            date: formData.date ? moment(formData.date).format('YYYY-MM-DD') : null,
        }       

        refetchServiceHours({firmId, date: moment(formDate).format('YYYY-MM-DD')})
        .unwrap()
        .then((res) => {

            setHours((state) => [])                
            res.hours.map((item) => {
                const hourParts = item.split(':')                    
                setHours((state) => [...state, {id: item, title: `${hourParts[0]}:${hourParts[1]}`}])
            })
            setHoursMessage(res.title)
            setNoRecordsMessage(res.no_records_title ? res.no_records_title : null)                
            
            res.hours.filter((item) => item == formTime).length
            ?
            create(_data)
            .unwrap()
            .then((res) => {
                toastRef.current.show({severity: 'success', summary: 'Запись на сервис прошла успешно'})
                setSuccessData(res)
                setSuccess(true)
                reset({...localData})
                // setVisible(false)            
                // onHide()
            })                    
            :
            toastRef.current.show({severity: 'warn', summary: 'Время записи изменено, так, как выбранное Вами время больше не доступно'})

        })        
        .catch((err) => {
            console.log(err)
            toastRef.current.show({severity: 'error', summary: `Ошибка записи на сервис`, detail: err.data && err.data.detail ? err.data.detail : 'Ошибка сервера' })
        })        
        
    }

    
    const handleCancel = () => {
        
    }

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    }


    const footer = () =>
        success
        ?
        null
        :         
        <div className='flex gap-3 mt-3'>                    
            <Button type="submit" onClick={handleSubmit(onSubmit)} label="Записаться" disabled={isCreating || isServiceTypesFetching || isUserLoading || isServiceHoursFetching}  />                        
        </div>
    
    
    const dateTemplate = (date) => {
        if (date.day > 10 && date.day < 15) {
            return (
                <strong style={{ textDecoration: 'line-through' }}>{date.day}</strong>
            );
        }

        return date.day;
    }

    const getContent = () => {
        if(success){
            let successMessage = settings.success_message
            successMessage = successMessage.replace('%name%', successData.name)
            successMessage = successMessage.replace('%service_type%', successData.service_type_printable )
            return <div className='mt-5 flex flex-col items-center gap-5'>
                <span className='text-left'>
                    {
                        successMessage.split("\n").map((item, idx) =>                             
                            <span key={idx}>
                                {item}
                                <br/><br/>
                            </span>                           
                        )                    
                    }
                </span>                
                <span className='mt-5'>
                    <Button label='Новая запись на сервис' onClick={() => {setSuccess(false); setSuccessData(null)}} />
                </span>
            </div>
        }

        if(isServiceTypesFetching || isUserLoading ){
            return (
                <div className='flex flex-col gap-4 mt-4'>
                    <Skeleton height='2.7rem'></Skeleton>
                    <Skeleton height='2.7rem'></Skeleton>
                    <Skeleton height='2.7rem'></Skeleton>
                    <div className="grid sm:grid-cols-2 gap-2">
                        <Skeleton height='2.7rem'></Skeleton>
                        <Skeleton height='2.7rem'></Skeleton>
                    </div>
                    <div className="grid sm:grid-cols-2 gap-2">
                        <Skeleton height='2.7rem'></Skeleton>
                        <Skeleton height='2.7rem'></Skeleton>
                    </div>                    
                </div>
            )               
        }

        return (
            <form ref={formRef} onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 mt-4" >

            <div className="field">
                <span className="p-float-label">
                    <Controller name="car_make_model" control={control} rules={{ required: 'Марка/модель/год выпуска автомобиля обязательна для заполнения.' }} render={({ field, fieldState }) => (
                        <InputText id={field.name} {...field} autoFocus className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} />
                    )} />
                    <label htmlFor="car_make_model" className={classNames({ 'p-error': errors.name })}>Марка/модель/год выпуска автомобиля *</label>
                </span>
                {getFormErrorMessage('car_make_model')}
            </div>

            {/* <div className="field">
                <span className="p-float-label">
                    <Controller name="service_type" control={control} rules={{ required: 'Вид обслуживания обязателен для заполнения.' }} render={({ field, fieldState }) => (
                        <Dropdown id={field.name} {...field} optionLabel="title" optionValue="id" options={localServiceTypes} 
                            className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })}                                        
                        />
                    )} />
                    <label htmlFor="service_type" className={classNames({ 'p-error': errors.name })}>Вид обслуживания *</label>
                </span>
                {getFormErrorMessage('service_type')}
            </div>

            {                            
                formServiceType == -1 
                ? */}
            {/* <div className="field">
                <span className="p-float-label">
                    <Controller name="service_type_other" control={control} rules={{ required: 'Вид обслуживания обязателен для заполнения.' }} render={({ field, fieldState }) => (
                        <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} />
                    )} />
                    <label htmlFor="service_type_other" className={classNames({ 'p-error': errors.name })}>Вид обслуживания *</label>
                </span>
                {getFormErrorMessage('service_type_other')}
            </div> */}
                {/* :
                null
            }                                     */}

            <div className="field">
                <span className="p-float-label">
                    <Controller name="comment" control={control} rules={{ required: 'Что требуется сделать обязательно для заполнения.' }}
                         render={({ field, fieldState }) => (
                        <InputTextarea id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} />
                    )} />
                    <label htmlFor="comment" className={classNames({ 'p-error': errors.name })}>Что требуется сделать (в свободной форме) *</label>
                </span>
                {getFormErrorMessage('comment')}
            </div>

            <div className="field">
                <span className="p-float-label">
                    <Controller name="name" control={control} rules={{ required: 'Ваше имя обязательно для заполнения.' }} render={({ field, fieldState }) => (
                        <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} />
                    )} />
                    <label htmlFor="name" className={classNames({ 'p-error': errors.name })}>Ваше имя *</label>
                </span>
                {getFormErrorMessage('name')}
            </div>

            <div className="grid sm:grid-cols-2 gap-2">

                <div className="field">
                    <span className="p-float-label">
                        <Controller name="phone" control={control}
                            rules={{ required: 'Телефон обязателен для заполнения', pattern: { value: /^(\+[1-9]{1})?\([0-9]{3}\)[0-9]{3}\-[0-9]{2}\-[0-9]{2}$/i, message: 'Телефон 1 должен быть номером телефона +7(999)999-99-99.' } }}
                            render={({ field, fieldState }) => (
                            <InputMask unmask={false} autoClear={false} id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })}  
                                mask="+7(999)999-99-99" placeholder="+7(999)999-99-99" />                            
                        )} />
                        <label htmlFor="phone" className={classNames({ 'p-error': errors.name })}>Телефон *</label>
                    </span>
                    {getFormErrorMessage('phone')}
                </div>

                <div className="field">
                    <span className="p-float-label">
                        <Controller name="email" control={control}
                            rules={{ pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Неправильная электронная почта.' }}}
                            render={({ field, fieldState }) => (
                                <InputText id={field.name} {...field}                                 
                                    className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })}  
                                />                            
                            )} />
                        <label htmlFor="email" className={classNames({ 'p-error': errors.name })}>Электронная почта</label>
                    </span>
                    {getFormErrorMessage('email')}
                </div>                

                

            </div>

            {/* <div className="field">
                <span className="p-float-label">
                    <Controller name="car_registration_number" control={control} rules={{ required: 'Гос. номер обязателен для заполнения.' }} render={({ field, fieldState }) => (
                        <InputText id={field.name} {...field}  className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} />
                    )} />
                    <label htmlFor="car_registration_number" className={classNames({ 'p-error': errors.name })}>Гос. номер *</label>
                </span>
                {getFormErrorMessage('car_registration_number')}
            </div> */}

            <div className="grid sm:grid-cols-2 gap-2">

                <div className="field">
                    <span className="p-float-label">
                        <Controller name="date" control={control} rules={{ required: 'Дата записи обязательна для заполнения.' }} render={({ field, fieldState }) => (
                            <Calendar id={field.name} {...field} 
                                className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })} 
                                locale='ru' dateFormat='dd/mm/yy'
                                minDate={new Date()}
                                showIcon
                                disabledDays={disabledWeekdays}
                            />
                        )} />
                        <label htmlFor="date" className={classNames({ 'p-error': errors.name })}>Дата записи *</label>
                    </span>
                    {getFormErrorMessage('date')}
                    {hoursMessage? <div className='text-red-400 bold'>{hoursMessage}</div> : null}
                    {noRecordsMessage? <div className='text-red-400 bold'>{noRecordsMessage}</div> : null}
                </div>

                <div className="field">
                    <span className="p-float-label">
                        <Controller name="time" control={control} rules={{ required: 'Время записи обязательно для заполнения.' }} render={({ field, fieldState }) => (
                            <Dropdown id={field.name} {...field} optionLabel="title" optionValue="id" options={hours} 
                                disabled={isServiceHoursFetching || !hours.length}
                                className={classNames({ 'p-invalid': fieldState.invalid, 'w-full': true })}                                        
                            />
                        )} />
                        <label htmlFor="time" className={classNames({ 'p-error': errors.name })}>Время записи *</label>
                    </span>
                    {getFormErrorMessage('time')}                
                </div>

            </div>

            <div className='text-gray-400 text-sm'>* поля обязательные для заполнения </div>

            
            

            
            
            <Button label='Submit' className='sr-only' type='submit' />
            
        </form>                    
        )

    }

    return (        
        <Dialog header={'Запись на сервис'} 
            footer={footer} visible={visible} onHide={onHide} blockScroll 
            closeOnEscape={false}
            breakpoints={{'767px': '100vw'}} style={{width: '600px'}}>
            { getContent() }
        </Dialog>     
    )    

}
